module.exports = __webpack_public_path__ + "img/PSSS-J-6.b12d3486.svg";